<div class="container-management">
    <figure>
        <!-- <img src="" alt="Administración imagen"> -->
    </figure>
    <h3>Administración</h3>
    <button class="secondaryButton" (click)="viweAdmin()">
        Administre trámites, reportes y contenido
    </button>
</div>